var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cx_payjp"},[(_vm.hasPerm == false)?_c('Button',{attrs:{"caption":_vm.caption,"disabled":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }